<div class="header-benefits flex flex-col md:flex-row justify-between bg-white px-4 py-6 md:p-8 gap-6 md:gap-[64px] lg:gap-[160px]" *ngIf="!isLoyalty2026Active">
    <!-- Columna izquierda - 50% del espacio -->
    <div class="flex flex-col md:flex-col-reverse justify-between w-full md:w-1/2 gap-4">
        <div class="header-benefits__date">
            <p class="typography-body-m-light m-0 p-0"><span class="typography-body-m-regular">{{'benefits_kb.applicable' |translate}}</span> {{'global.from' |translate}} 1/01/2025 {{'global.to' |translate}} 31/12/25</p>
        </div>
    <h1
      class="header-benefits__title m-0 p-0"
      [innerHTML]="'benefits_kb.title' | translate : { currentLoyalty: userInfo.loyaltyLevel, nextLoyalty: nextLevel?.loyaltyStatus }">
    </h1>

    </div>

    <!-- Columna derecha - 50% del espacio -->
    <div class="flex flex-col w-full md:w-1/2">
        <span class="typography-body-l-light">{{ 'benefits_kb.register_x_sales' | translate: {salesNeeded: nextLevel?.ytdSales, brandPresence: nextLevel?.silestonePresence} }}</span>
        <app-stats-benefits class="w-full pt-6 pb-4"></app-stats-benefits>
        <div class="grid grid-cols-3 gap-6">
            <!-- <app-button  [secondary]="true" [ghost]="true" [showIcon]="true" [iconType]="'arrow'" [iconPosition]="'end'" (onClick)="goToRegisterSales()" [size]="'medium'">
                {{'home.privatearea30_register_sale_item_title' | translate}}
            </app-button> -->

              <app-link class="cosentino-link text-primary-default" contentClass="text-primary-default" [size]="'medium'" [gtmLabel]="'link_go-to--my-sales'" (onClick)="goToRegisterSales()">
                {{'home.privatearea30_register_sale_item_title' | translate}}
              </app-link>

              <app-link class="cosentino-link text-primary-default" contentClass="text-primary-default" [size]="'medium'" [gtmLabel]="'link_go-to--display'" (onClick)="goToDisplays()">
                {{'home.solicitar_exposicion_home' | translate}}
              </app-link>
        </div>
    </div>
</div>
<div class="header-benefits flex flex-col md:flex-row justify-between bg-white px-4 py-6 md:p-8 " *ngIf="isLoyalty2026Active">
  <div class="flex flex-col gap-4 md:flex-row w-full">
    <!-- Primera columna - 60% -->
    <div class="w-full md:w-[60%] h-full flex flex-col justify-between">

        <div class="loyaltylevel-message mb-4" [innerHTML]="getTitleText()"></div>
        <div class="card-description">{{ progressText }}</div>
        <div class="progress-container">
          <div class="progress-bar">
            <div class="progress-fill" [style.width.%]="getLoyaltyProgress()"></div>
          </div>
          <div class="progress-labels">
            <span [class]="getNextYearLevel() === 'advanced' ? 'typography-body-s-regular' : 'typography-body-s-light textSecondary-color'">Advanced</span>
            <span [class]="getNextYearLevel() === 'elite' ? 'typography-body-s-regular elite-marker' : 'typography-body-s-light elite-marker textSecondary-color'">Elite</span>
            <span [class]="getNextYearLevel() === 'premium' ? 'typography-body-s-regular' : 'typography-body-s-light textSecondary-color'">Premium</span>
          </div>
        </div>

    </div>
    
    <!-- Segunda columna - 40% con 3 columnas internas -->
    <div class="w-full md:w-[40%]">
      <div class="flex flex-col md:flex-row gap-4 md:gap-6 h-full">
        <div class="flex flex-col gap-2 items-center justify-between border-r border-[#D9D9D9] w-full md:w-[70%]">
          <div class="flex flex-row w-full">
            <div class="deadline p-1">
              <span class="flex align-center" *ngIf="!hasAchievedObjectives()"><svg xmlns="http://www.w3.org/2000/svg"
                  width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M11.5 16.5H12.5V11H11.5V16.5ZM12 9.575C12.1667 9.575 12.3127 9.51667 12.438 9.4C12.5627 9.28333 12.625 9.13333 12.625 8.95C12.625 8.78333 12.5627 8.64167 12.438 8.525C12.3127 8.40833 12.1667 8.35 12 8.35C11.8333 8.35 11.6873 8.40833 11.562 8.525C11.4373 8.64167 11.375 8.78333 11.375 8.95C11.375 9.13333 11.4373 9.28333 11.562 9.4C11.6873 9.51667 11.8333 9.575 12 9.575ZM12 21C10.75 21 9.57933 20.7627 8.488 20.288C7.396 19.8127 6.446 19.1707 5.638 18.362C4.82933 17.554 4.18733 16.604 3.712 15.512C3.23733 14.4207 3 13.25 3 12C3 10.75 3.23733 9.579 3.712 8.487C4.18733 7.39567 4.82933 6.44567 5.638 5.637C6.446 4.829 7.396 4.18733 8.488 3.712C9.57933 3.23733 10.75 3 12 3C13.25 3 14.421 3.23733 15.513 3.712C16.6043 4.18733 17.5543 4.829 18.363 5.637C19.171 6.44567 19.8127 7.39567 20.288 8.487C20.7627 9.579 21 10.75 21 12C21 13.25 20.7627 14.4207 20.288 15.512C19.8127 16.604 19.171 17.554 18.363 18.362C17.5543 19.1707 16.6043 19.8127 15.513 20.288C14.421 20.7627 13.25 21 12 21ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z"
                    fill="#232323" />
                </svg></span>
              <span class="flex align-center" *ngIf="hasAchievedObjectives()"><svg xmlns="http://www.w3.org/2000/svg" width="24"
                  height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M10.55 15.9L16.95 9.5L16.25 8.8L10.55 14.5L7.7 11.65L7 12.35L10.55 15.9ZM12 21C10.75 21 9.57933 20.7627 8.488 20.288C7.396 19.8127 6.446 19.1707 5.638 18.362C4.82933 17.554 4.18733 16.604 3.712 15.512C3.23733 14.4207 3 13.25 3 12C3 10.75 3.23733 9.579 3.712 8.487C4.18733 7.39567 4.82933 6.44567 5.638 5.637C6.446 4.829 7.396 4.18733 8.488 3.712C9.57933 3.23733 10.75 3 12 3C13.25 3 14.421 3.23733 15.513 3.712C16.6043 4.18733 17.5543 4.829 18.363 5.637C19.171 6.44567 19.8127 7.39567 20.288 8.487C20.7627 9.579 21 10.75 21 12C21 13.25 20.7627 14.4207 20.288 15.512C19.8127 16.604 19.171 17.554 18.363 18.362C17.5543 19.1707 16.6043 19.8127 15.513 20.288C14.421 20.7627 13.25 21 12 21ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z"
                    fill="#232323" />
                </svg></span>
              <span class="typography-body-xs-regular" *ngIf="!hasAchievedObjectives()">{{ 'benefits_kb.loyalty_2026.reach_goals_before_deadline' | translate }} <span
                  class="date-highlight">{{ getCurrentYearDeadline() }}</span></span>
              <span class="typography-body-s-regular congratulations" *ngIf="hasAchievedObjectives()">{{ 'benefits_kb.loyalty_2026.congratulations_goals_reached' | translate }}</span>
            </div>

          </div>
          <div class="flex flex-row gap-2 items-center justify-around  h-full w-full">

            <!-- Col 1: Ventas -->
            <div class="flex flex-col gap-2 items-center justify-between">
              <div class="typography-body-s-light">{{ 'benefits_kb.loyalty_2026.registered_sales' | translate }}</div>
              <div>
                <span class="custom-current">{{ currentSales }}</span>
                <span class="objetives">/{{ getSalesObjective() }}</span>
              </div>
              <app-link class="primaryDefault-color" (click)="goToRegisterSales()">
                <div class="flex items-center">
                  <div class="link-s">{{ 'benefits_kb.loyalty_2026.register_sale' | translate }}</div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path
                      d="M6.26647 11.5333L5.7998 11.0667L8.86647 7.99999L5.7998 4.93333L6.26647 4.46666L9.7998 7.99999L6.26647 11.5333Z"
                      fill="#365BCA" />
                  </svg>
                </div>
              </app-link>
            </div>

            <!-- Col 2: Exposiciones -->
            <div class="flex flex-col gap-2 items-center justify-between">
              <div class="typography-body-s-light">{{ 'benefits_kb.loyalty_2026.active_displays' | translate }}</div>
              <div>
                <span class="custom-current">{{ currentExpositions }}</span>
                <span class="objetives">/{{ getDisplaysObjective() }}</span>
              </div>
              <app-link class="primaryDefault-color" (click)="goToDisplays()">
                <div class="flex items-center">
                  <div class="link-s">{{ 'benefits_kb.loyalty_2026.request_display' | translate }}</div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path
                      d="M6.26647 11.5333L5.7998 11.0667L8.86647 7.99999L5.7998 4.93333L6.26647 4.46666L9.7998 7.99999L6.26647 11.5333Z"
                      fill="#365BCA" />
                  </svg>
                </div>
              </app-link>
            </div>
          </div>

        </div>

        <!-- Col 3: Puntos -->
        <div class="flex flex-col gap-2 items-center justify-end h-full w-full md:w-[30%]">
          <!-- Caso: ADVANCED sin puntos -->
          <ng-container *ngIf="!availableActios || availableActios === 0">
            <div class="typography-body-s-regular text-center">{{ 'benefits_kb.loyalty_2026.level_up_earn_points' | translate }}</div>
            <app-link class="primaryDefault-color" (click)="discoverMore()">
              <div class="flex items-center">
                <div class="link-s">{{ 'benefits_kb.loyalty_2026.discover_more' | translate }}</div>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M6.26647 11.5333L5.7998 11.0667L8.86647 7.99999L5.7998 4.93333L6.26647 4.46666L9.7998 7.99999L6.26647 11.5333Z" fill="#365BCA" />
                </svg>
              </div>
            </app-link>
          </ng-container>

          <!-- Caso: Resto (con puntos o no ADVANCED) -->
          <ng-container *ngIf="availableActios && availableActios > 0">
            <div class="typography-body-s-light">{{ 'benefits_kb.loyalty_2026.points_available' | translate }}</div>
            <div><span class="custom-current">{{ availableActios }}</span></div>
              <app-link *ngIf="canExchangePoints" class="primaryDefault-color" (click)="exchangePoints()">
              <div class="flex items-center">
                <div class="link-s">{{ 'benefits_kb.loyalty_2026.redeem_points' | translate }}</div>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M6.26647 11.5333L5.7998 11.0667L8.86647 7.99999L5.7998 4.93333L6.26647 4.46666L9.7998 7.99999L6.26647 11.5333Z" fill="#365BCA" />
                </svg>
              </div>
            </app-link>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>